import { render, staticRenderFns } from "./CenterApp.vue?vue&type=template&id=34bf0ab0&scoped=true"
import script from "./CenterApp.vue?vue&type=script&lang=js"
export * from "./CenterApp.vue?vue&type=script&lang=js"
import style0 from "./CenterApp.vue?vue&type=style&index=0&id=34bf0ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bf0ab0",
  null
  
)

export default component.exports